import Axios from 'axios';

class ReenrollmentContractsService {
  createBoleto(reenrollmentId) {
    return Axios.post('/admin/rematricula/create-boleto', { reenrollment_id: reenrollmentId });
  }

  downloadBoleto(paymentPromiseId) {
    return Axios
      .get('/admin/rematricula/download-boleto', {
        params: {
          payment_promise_id: paymentPromiseId,
        },
        responseType: 'blob',
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        // prevent IE download attribute error
        if ('msSaveOrOpenBlob' in window.navigator) {
          return window.navigator.msSaveOrOpenBlob(blob, 'Boleto de rematrícula');
        }

        return this.createLinkToDownload(blob, 'Boleto de rematrícula');
      });
  }

  createLinkToDownload(blob, fileName) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.setAttribute('download', fileName);
    link.setAttribute('href', url);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  updateReenrollment(reenrollmentId, params) {
    return Axios.put(`/admin/rematricula/${reenrollmentId}`, params);
  }

  reenroll(reenrollmentId, forceReenroll) {
    return Axios.post(`/admin/rematricula/${reenrollmentId}/reenroll`, { force_reenroll: forceReenroll });
  }

  cancelReenrollment(reenrollmentId) {
    return Axios.post(`/admin/rematricula/${reenrollmentId}/cancel`);
  }

  enums() {
    return Axios.get('/admin/rematricula/enums');
  }
}

export default new ReenrollmentContractsService();
